import { useTextContent } from '@modules/changeman/pages/text-content/text-content.hook';
import Loading from '@shared/components/loading';
import PageHeader from '@shared/components/page-header';
import { InputText } from '@shared/old-form';

const MainChangemanPage = () => {
  const {
    current,
    entity,
    loading_current,
    saving,
    downloadText,
    downloadContent,
    handleInputChange,
    handleReceive,
    handleSend,
    handleRemove,
  } = useTextContent();

  const renderTextArea = (
    label: string,
    field: string,
    value: string,
    rows: number = 5,
    onChange?: (event: any) => void,
  ) => (
    <div>
      <label htmlFor={field} className="form-label">
        {label}
      </label>
      <textarea
        className={'form-control' + (!onChange ? ' bg-light' : '')}
        id={field}
        name={field}
        rows={rows}
        value={value}
        readOnly={!onChange}
        onChange={onChange}
      />
      <span className="small text-muted">{value.length} caracteres</span>
    </div>
  );

  return (
    <>
      <PageHeader
        title="Changeman"
        actions={[
          { title: 'Excluir', onClick: handleRemove },
          { title: 'Receber', onClick: handleReceive },
          { title: 'Enviar', onClick: handleSend },
        ]}
      />
      <Loading active={loading_current || saving} />
      <div className="row">
        <InputText
          autoComplete="off"
          required={true}
          label="Nome"
          name="name"
          value={entity.name}
          className="col-12"
          onChange={handleInputChange}
        />
      </div>

      <div className="row">
        <div className="col">
          {renderTextArea('Conteúdo', 'content', entity.content, 10, handleInputChange)}
        </div>
        <div className="col">
          {renderTextArea('Conteúdo retornado', 'content', current?.content ?? '', 10)}
        </div>
      </div>

      <div className="d-flex justify-content-end gap-2">
        <button className="btn btn-secondary" type="button" onClick={downloadText}>
          Salvar (texto)
        </button>
        <button className="btn btn-dark" type="button" onClick={downloadContent}>
          Salvar (base64)
        </button>
      </div>
    </>
  );
};

export default MainChangemanPage;
